<div class="field-container">
    <p>{{value}}</p>
    <button
      #popperTarget
      [popper]="'Copiado'"
      [popperTrigger]="'mousedown'"
      [popperPlacement]="'top'"
      [popperShowOnStart]="false"
      [popperTimeout]=1000
      type="button"
      *ngIf="value"
      ngxClipboard
      [cbContent]="value"
      mat-icon-button
      (click)='copy()'
      [ngClass]="{breathIdle: idle }"
    >
      <fa-icon [icon]="['far', 'clone']" size="lg" flip="both"></fa-icon>
    </button>
</div>
<div class="copy-text">Copiar</div>
